/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CRSFTorrent } from './CRSFTorrent';
import {
    CRSFTorrentFromJSON,
    CRSFTorrentFromJSONTyped,
    CRSFTorrentToJSON,
} from './CRSFTorrent';

/**
 * 
 * @export
 * @interface CRSFTorrentsPagedResponse
 */
export interface CRSFTorrentsPagedResponse {
    /**
     * 
     * @type {number}
     * @memberof CRSFTorrentsPagedResponse
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof CRSFTorrentsPagedResponse
     */
    page_size?: number;
    /**
     * 
     * @type {Array<CRSFTorrent>}
     * @memberof CRSFTorrentsPagedResponse
     */
    results?: Array<CRSFTorrent>;
    /**
     * 
     * @type {number}
     * @memberof CRSFTorrentsPagedResponse
     */
    total?: number;
}

/**
 * Check if a given object implements the CRSFTorrentsPagedResponse interface.
 */
export function instanceOfCRSFTorrentsPagedResponse(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function CRSFTorrentsPagedResponseFromJSON(json: any): CRSFTorrentsPagedResponse {
    return CRSFTorrentsPagedResponseFromJSONTyped(json, false);
}

export function CRSFTorrentsPagedResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CRSFTorrentsPagedResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'page': !exists(json, 'page') ? undefined : json['page'],
        'page_size': !exists(json, 'page_size') ? undefined : json['page_size'],
        'results': !exists(json, 'results') ? undefined : ((json['results'] as Array<any>).map(CRSFTorrentFromJSON)),
        'total': !exists(json, 'total') ? undefined : json['total'],
    };
}

export function CRSFTorrentsPagedResponseToJSON(value?: CRSFTorrentsPagedResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'page': value.page,
        'page_size': value.page_size,
        'results': value.results === undefined ? undefined : ((value.results as Array<any>).map(CRSFTorrentToJSON)),
        'total': value.total,
    };
}

